import {
	DEFAULT_FRAME_FONT,
	DEFAULT_FRAME_TEXT_MAX_SIZE,
	DEFAULT_FRAME_TEXT_MAX_WIDTH,
} from 'features/generator/qrFrames/qrFramesConstants'
import { useLayoutEffect, useState } from 'react'

import { measureFitTextSize } from './measureFitTextSize'

export const useFrameFontSize = ({
	text,
	maxWidth,
	maxSize,
	fontFamily,
}: {
	text: string
	maxWidth?: number
	maxSize?: number
	fontFamily?: string
}) => {
	const [fontSize, setFontSize] = useState(0)

	useLayoutEffect(() => {
		;(async () => {
			const fittedFontSize = await measureFitTextSize({
				text,
				maxWidth: maxWidth || DEFAULT_FRAME_TEXT_MAX_WIDTH,
				maxSize: maxSize || DEFAULT_FRAME_TEXT_MAX_SIZE,
				fontFamily: fontFamily || DEFAULT_FRAME_FONT,
			})
			setFontSize(fittedFontSize)
		})()
	}, [fontFamily, maxSize, maxWidth, text])

	return fontSize
}
